import { RMTableHeadingWithAddRemoveBtns } from 'components/customComponents/Controls/RMTableHeadingWithAddRemoveBtns';
import React from 'react';
import { IngredientItemsListProps } from './IngredientsConstants';

const IngredientsGenericList = (props: IngredientItemsListProps) => {
  const {
    name,
    iterator,
    selectedItems,
    onClickAdd,
    onClickDelete,
    callbackMethod,
    showAddButton,
    conflictResolutionType,
    selectOrUnselect,
  } = props;
  return (
    <>
      <div id="ingredients-generic-list-wrapper" className="properties-list-div">
        <RMTableHeadingWithAddRemoveBtns
          tableHeading={name}
          onClickAddBtn={() => onClickAdd(conflictResolutionType)}
          onClickRemoveBtn={() => onClickDelete(conflictResolutionType)}
          showAddButton={showAddButton}
        />
        <div id="ingredients-generic-list-items" className="wizard-list incoming-ingredients-list">
          {iterator?.map((item, i) => {
            item.name = item.name ? item.name : item.number;
            return (
              <div
                id={`ingredients-generic-list-item-${i}-${item.name}`}
                key={`itr${i}`}
                className={`ingredient-wizard-list-item wizard-list-item ${
                  selectedItems &&
                  selectedItems.some(
                    (lItem) =>
                      lItem.name === item.name && lItem.value === conflictResolutionType,
                  )
                    ? 'wizard-list-item-active'
                    : ''
                }`}
                onClick={() => {
                  const tempItems = selectOrUnselect(selectedItems, item);
                  callbackMethod([...tempItems]);
                }}
                title={item.name}
              >
                {item.name}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default React.memo(IngredientsGenericList);
